import script from "./RcDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RcDialog.vue?vue&type=script&setup=true&lang=js"

import "./RcDialog.vue?vue&type=style&index=0&id=2f42412a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f42412a"]])

export default __exports__